@if (options) {
  <div class="question-form__array">
    <div class="header row">
      <span class="label">Options</span>
    </div>

    <div class="question-form_array_list">
      @for (optionCtrl of options.controls; track optionCtrl.value.id) {
        <div [formGroup]="optionCtrl" class="editor-question-form__input">
          <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
            <div matPrefix class="variable-choice__id eiq-id-badge">
              <span>{{ optionCtrl.value.id }}</span>
            </div>
            <span matTextPrefix class="variable-choice__value fs__sm fw__500">{{ optionCtrl.value.value }}</span>
            <input matInput formControlName="text" autocomplete="off" />
          </mat-form-field>
        </div>
      }
    </div>
  </div>
}
